import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'zcurrency'
})
export class ZCurrencyPipe implements PipeTransform {

    transform(value: number): string {
        let currency = '€';
        let nf = new Intl.NumberFormat('it-IT', { minimumFractionDigits: 0, maximumFractionDigits: 0});
        let val = nf.format(value);
        
        return currency +' '+ val;
    }
}


// WEBPACK FOOTER //
// ./src/pipes/zcurrency.ts